export type Theme = "dark" | "light" | "system" | "ocean" | "sunset" | "forest";

export function isValidTheme(theme: string): theme is Theme {
  return ["dark", "light", "system", "ocean", "sunset", "forest"].includes(theme);
}
